// Shared test IDs — used in components and E2E tests
// Import from here in both places to keep selectors in sync

// Nav
export const NAV_LOGIN_BUTTON = "nav-login-button";
export const NAV_USER_MENU = "nav-user-menu";

// Browse
export const EXPERIENCE_CARD = "experience-card";
export const EXPERIENCE_GRID = "experience-grid";
export const ADMIN_FAB = "admin-fab";

// Detail
export const DETAIL_HERO = "detail-hero";
export const DETAIL_EDIT_LINK = "detail-edit-link";

// Editor
export const EDITOR_TITLE = "editor-title";
export const EDITOR_SLUG = "editor-slug";
export const EDITOR_SUBTITLE = "editor-subtitle";
export const EDITOR_SAVE = "editor-save";
export const EDITOR_DELETE = "editor-delete";

// Account
export const ACCOUNT_EMAIL = "account-email";
export const ACCOUNT_NAME = "account-name";
export const ACCOUNT_EDIT_PROFILE = "account-edit-profile";
export const ACCOUNT_CHANGE_PASSWORD = "account-change-password";
export const ACCOUNT_CHANGE_EMAIL = "account-change-email";